"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyV1PutUserFacebook = void 0;
exports.v1PutUserFacebookSetMock = v1PutUserFacebookSetMock;
exports.v1PutUserFacebook = v1PutUserFacebook;
exports.useMutationV1PutUserFacebook = useMutationV1PutUserFacebook;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function v1PutUserFacebookSetMock(mock) {
    setMock = mock;
}
async function v1PutUserFacebook(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/cockatoo/v1/user/facebook`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.token = params.token;
    if ((params.forceStatusCheck) && (await (0, is_down_1.cockatooIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'PUT', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyV1PutUserFacebook = 'cockatoo:v1PutUserFacebook:put';
function useMutationV1PutUserFacebook(mutationOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    return reactQuery.useMutation(mutationFn, Object.assign({ mutationKey: exports.useKeyV1PutUserFacebook }, mutationOptions));
}
function mutationFn({ params }) {
    const promise = v1PutUserFacebook(params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=v1-put-user-facebook.js.map